import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./user/home";
import CustomerLogin from "./user/login";
import BookingPage from "./user/book-room";
import AddRoomForm from "./admin/room/addRoom";
import AdminLogin from "./admin/login";
import CreateUser from "./admin/user/createUser";
import Dashboard from "./admin/dashboard";
import ProtectedRoute from "./components/Nav/ProtectedRoute";
import RoomInfo from "./admin/room/view-rooms";
import Transactions from "./admin/bookings";
import UserProfile from "./user/profile";
import BookForUser from "./admin/user/book_for_user";
import AboutUs from "./user/about";
import ContactUs from "./user/contact";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />

        <Route path="/babafakruddin-admin-login" element={<AdminLogin />} />
        <Route path="/login" element={<CustomerLogin />} />
        <Route
          path="/booking/:roomId"
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <BookingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={[1]}>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/babafakruddin/admin/createUser"
          element={
            <ProtectedRoute allowedRoles={[2, 3]}>
              <CreateUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/babafakruddin/admin/book_for_customer"
          element={
            <ProtectedRoute allowedRoles={[2, 3]}>
              <BookForUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/babafakruddin/admin/addRooms"
          element={
            <ProtectedRoute allowedRoles={[2, 3]}>
              <AddRoomForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/babafakruddin/admin/view-transaction-details"
          element={
            <ProtectedRoute allowedRoles={[2]}>
              <Transactions />
            </ProtectedRoute>
          }
        />

        <Route
          path="/babafakruddin/admin/dashboard"
          element={
            <ProtectedRoute allowedRoles={[2, 3]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/babafakruddin/admin/view-rooms"
          element={
            <ProtectedRoute allowedRoles={[2, 3]}>
              <RoomInfo />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
